<template>
  <div class="footer-content">
    <!-- 版权文字：独立一行，绝对居中 -->
    <div class="footer-copyright">
      <p>© 2026 公司自研平台. All rights reserved by LOTOV.</p>
    </div>
 
  </div>
</template>

<script setup>
const customFooterAction = () => {
  console.log('Footer 自定义动作');
};
</script>

<style scoped>
.footer-content {
  display: flex;
  flex-direction: column;
  justify-content: center;          /* 垂直居中整个内容 */
  align-items: center;              /* 水平居中 */
  height: 100px;                    /* 强制固定高度 */
  padding: 10px 20px;               /* 上下留10px呼吸空间，左右20px */
  background-color: #fff;
  border-top: 1px solid #e8e8e8;
  box-sizing: border-box;
  margin: 0;
  width: 100%;
}

/* 版权文字行 */
.footer-copyright {
  text-align: center;
  margin: 0 0 8px 0;                /* 只在底部留间距 */
  width: 100%;
  flex-shrink: 0;
}

.footer-copyright p {
  margin: 0;
  font-size: 14px;
  color: #909399;
}

</style>